'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UIDropdownFooter = function UIDropdownFooter(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _reactUtils.classNames)('private-dropdown__footer-container', className) },
    children
  );
};

UIDropdownFooter.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};

exports.default = UIDropdownFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dropdown/UIDropdownFooter.js
// module id = 306
// module chunks = 0